import React from 'react';
import { NavLink } from 'react-router-dom';

const videoSrc = require('./../../images/video_main.mp4');

class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.paragraphRef = React.createRef();
    }

    componentDidMount() {
        const paragraph = this.paragraphRef.current;
        if (!paragraph) return;

        function textEffect(animationName) {
            var text = paragraph.innerHTML,
                chars = text.length,
                newText = '',
                animation = animationName,
                i;

            for (i = 0; i < chars; i += 1) {
                newText += '<i>' + text.charAt(i) + '</i>';
            }

            paragraph.innerHTML = newText;

            var wrappedChars = paragraph.getElementsByTagName('i'),
                wrappedCharsLen = wrappedChars.length,
                j = 0;

            function addEffect() {
                setTimeout(function () {
                    if (wrappedChars[j]) {
                        wrappedChars[j].className = animation;
                    }
                    j += 1;
                    if (j < wrappedCharsLen) {
                        addEffect();
                    }
                }, 100);
            }

            addEffect();
        }

        textEffect('fly-in-out');
    }

    render() {
        return (
            <section className="hero-video-section">
                <video className="hero-video-section__bg" autoPlay muted loop playsInline>
                    <source src={videoSrc} type="video/mp4" />
                </video>
                <div className="hero-video-section__overlay" />
                <div className="hero-video-section__content">
                    <div className="hero-video-section__copy ">
                        <h1 className="hero-video-section__title">
                            <div className="message text">
                                <div className="word1">Crafting Your Legacy Today</div>
                                <div className="word2">Quality You Can Trust In</div>
                                <div className="word3">Building The Future Together</div>
                            </div>
                        </h1>
                        <p ref={this.paragraphRef} className="hero-video-section__description">
                            Where imagination meets expert craftsmanship, we turn blueprints into breathtaking structures.
                        </p>
                        {/* Main hero button*/}
                                <div className="tp-caption tp-resizeme" id="slide-903-layer-5" data-x="['left','left','left','left']" data-hoffset="['50','130','130','130']" data-y="['middle','middle','middle','middle']" data-voffset="['90','90','90','130']" data-lineheight="['none','none','none','none']" data-width="['300','300','300','300']" data-height="['none','none','none','none']" data-whitespace="['normal','normal','normal','normal']" data-type="text" data-responsive_offset="on" data-frames="[{&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;&quot;,&quot;mask&quot;:&quot;x:0px;y:0px;s:inherit;e:inherit;&quot;,&quot;speed&quot;:1500,&quot;to&quot;:&quot;o:1;&quot;,&quot;delay&quot;:1000,&quot;ease&quot;:&quot;Power3.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:1000,&quot;to&quot;:&quot;auto:auto;&quot;,&quot;mask&quot;:&quot;x:0;y:0;s:inherit;e:inherit;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['left','left','left','left']" data-paddingtop="[0,0,0,0]" data-paddingright="[0,0,0,0]" data-paddingbottom="[0,0,0,0]" data-paddingleft="[0,0,0,0]" style={{ zIndex: 100, textTransform: 'uppercase', margin: 10 }}>
                                    <NavLink to="/about" className="site-button-secondry btn-effect">More About</NavLink>
                                </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Slider;
